const AUTH_RETURN_KEY = 'fongpt-auth-return-to';

export function safeLocalPath(path: string | null | undefined): string | null {
  const hasControlCharacter = path
    ? Array.from(path).some((character) => {
        const code = character.charCodeAt(0);
        return code <= 31 || code === 127;
      })
    : false;
  if (
    !path ||
    !path.startsWith('/') ||
    path.startsWith('//') ||
    path.includes('\\') ||
    hasControlCharacter
  ) {
    return null;
  }

  try {
    const base = 'https://fongpt.invalid';
    const resolved = new URL(path, base);
    return resolved.origin === base ? path : null;
  } catch {
    return null;
  }
}

export function rememberAuthReturnTo(path: string): void {
  const safePath = safeLocalPath(path);
  if (!safePath) return;
  try {
    sessionStorage.setItem(AUTH_RETURN_KEY, safePath);
  } catch {
    // Storage can be disabled; login still works and falls back to home.
  }
}

export function consumeAuthReturnTo(): string {
  try {
    const path = safeLocalPath(sessionStorage.getItem(AUTH_RETURN_KEY));
    sessionStorage.removeItem(AUTH_RETURN_KEY);
    return path || '/';
  } catch {
    return '/';
  }
}
